import Via from "./Via";
import ResultFormatting from "./ResultFormatting";
import Dimensions from "./Dimensions";
import CalculationOptions from "./CalculationOptions";

export default class RouteCalculatorRequest {

    public startISRS: string;
    public endISRS: string;
    public viaPoints: Via[];
    public shipCategory: number;
    public shipDimensions: Dimensions;
    public shipSpeed: number;
    public departAt: Date;
    public arriveBy: Date;
    public calculationOptions: CalculationOptions;
    public resultFormatting: ResultFormatting;

}